(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 18557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99535);
/* harmony import */ var _Layout_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34171);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(309);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46098);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


var _excluded = ["children", "redirect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var DefaultLayout = function DefaultLayout(_ref) {
  var children = _ref.children,
      redirect = _ref.redirect,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  (0,_hooks_useMiddleware__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(false, '/dashboard/invoices', redirect);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Layout_styles__WEBPACK_IMPORTED_MODULE_2__/* .DefaultLayoutGrid */ .Er, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X2, {
        justify: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_base__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg, {
          cols: 12,
          md: 8,
          lg: 6,
          xl: 5,
          children: children
        })
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);

/***/ }),

/***/ 34171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ DefaultLayoutGrid; },
/* harmony export */   "G$": function() { return /* binding */ AsideLayoutSidebar; },
/* harmony export */   "Ku": function() { return /* binding */ LayoutMain; },
/* harmony export */   "T9": function() { return /* binding */ AsideLayoutContainer; },
/* harmony export */   "TN": function() { return /* binding */ LayoutLoadingContainer; },
/* harmony export */   "g9": function() { return /* binding */ AsideLayoutContent; },
/* harmony export */   "oQ": function() { return /* binding */ AsideLayoutSidebarContainer; },
/* harmony export */   "rn": function() { return /* binding */ AsideLayoutContentContainer; },
/* harmony export */   "vC": function() { return /* binding */ DashboardLayoutContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99535);
/* harmony import */ var _config_config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56626);



var LayoutMain = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].main.withConfig */ .ZP.main.withConfig({
  displayName: "Layoutstyles__LayoutMain",
  componentId: "sc-mwnvy-0"
})(["", ""], {
  "height": "100%",
  "width": "100%"
});
var LayoutLoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__LayoutLoadingContainer",
  componentId: "sc-mwnvy-1"
})(["", ""], {
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center",
  "width": "100%",
  "height": "100vh"
});
var DefaultLayoutGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_base__WEBPACK_IMPORTED_MODULE_0__/* .Grid */ .rj).withConfig({
  displayName: "Layoutstyles__DefaultLayoutGrid",
  componentId: "sc-mwnvy-2"
})(["", ""], {
  "display": "flex",
  "minHeight": "100vh",
  "flexDirection": "column",
  "justifyContent": "center",
  "alignItems": "center"
});
/*
 DASHBOARD LAYOUT STYLES
*/

var DashboardLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__DashboardLayoutContainer",
  componentId: "sc-mwnvy-3"
})(["", " max-width:90rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
});
/*
 ASIDE LAYOUT STYLES
*/

var AsideLayoutContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContainer",
  componentId: "sc-mwnvy-4"
})(["", " grid-template-columns:", " auto"], {
  "display": "grid"
}, _config_config_json__WEBPACK_IMPORTED_MODULE_1__/* .theme.asideLayout.sidebarWidth */ .rS.SV.h);
var AsideLayoutSidebar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].aside.withConfig */ .ZP.aside.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebar",
  componentId: "sc-mwnvy-5"
})(["", ""], {
  "display": "block",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))",
  "position": "relative",
  "maxHeight": "100vh"
});
var AsideLayoutSidebarContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutSidebarContainer",
  componentId: "sc-mwnvy-6"
})(["", " ", ""], {
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "1.25rem",
  "paddingBottom": "1.25rem",
  "height": "100%",
  "overflowY": "auto"
}, function (_ref) {
  var $disableScroll = _ref.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContentContainer",
  componentId: "sc-mwnvy-7"
})(["", " ", ""], {
  "paddingLeft": "1.25rem",
  "paddingRight": "1.25rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem",
  "maxHeight": "100vh",
  "overflowY": "auto"
}, function (_ref2) {
  var $disableScroll = _ref2.$disableScroll;
  return $disableScroll ? {
    "overflowY": "hidden"
  } : {
    "overflowY": "auto"
  };
});
var AsideLayoutContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Layoutstyles__AsideLayoutContent",
  componentId: "sc-mwnvy-8"
})(["", " width:45.875rem;"], {
  "marginLeft": "auto",
  "marginRight": "auto"
});

/***/ }),

/***/ 309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./components/layout/Layout.styles.tsx
var Layout_styles = __webpack_require__(34171);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.styles.tsx

var ScrollTopButtonRoot = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ScrollTopButtonstyles__ScrollTopButtonRoot",
  componentId: "sc-g7p5q0-0"
})(["", ""], {
  "zIndex": "50",
  "marginRight": "0.5rem",
  "position": "fixed",
  "bottom": "1.5rem",
  "right": "1rem",
  "width": "3.5rem",
  "height": "3.5rem",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgba(14, 40, 190, var(--tw-bg-opacity))",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(131, 166, 234, var(--tw-bg-opacity))"
  },
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center"
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/base/scroll-top-button/ScrollTopButton.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaximizeIcon = function MaximizeIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 14C3.55228 14 4 14.4477 4 15V20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3C2.44772 22 2 21.5523 2 21V15C2 14.4477 2.44772 14 3 14Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
    })]
  }));
};

MaximizeIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#ffffff",
  xmlns: "http://www.w3.org/2000/svg"
};




var ScrollTopButton = function ScrollTopButton(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  var onClick = function onClick(event) {
    props === null || props === void 0 ? void 0 : props.onClick(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollTopButtonRoot, _objectSpread(_objectSpread({}, props), {}, {
    onClick: onClick,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaximizeIcon, {
      className: "fill-white"
    })
  }));
};

/* harmony default export */ var scroll_top_button_ScrollTopButton = (ScrollTopButton);
// EXTERNAL MODULE: ./config/config.json
var config = __webpack_require__(56626);
// EXTERNAL MODULE: ./hooks/invoice-upload/useInvoiceUploadContext.ts
var useInvoiceUploadContext = __webpack_require__(10459);
;// CONCATENATED MODULE: ./components/layout/Layout.tsx


function Layout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Layout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Layout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Layout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var LoadingSpinIcon = function LoadingSpinIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Layout_objectSpread(Layout_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "primary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2.4C6.69807 2.4 2.4 6.69807 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "secondary",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8 1.2C10.8 0.537258 11.3373 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 11.3373 0.537258 10.8 1.2 10.8C1.86274 10.8 2.4 11.3373 2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C11.3373 2.4 10.8 1.86274 10.8 1.2Z",
      fill: "white"
    })]
  }));
};

LoadingSpinIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#BBC9DE",
  xmlns: "http://www.w3.org/2000/svg"
};








var Layout = function Layout(_ref) {
  var children = _ref.children,
      headers = _ref.headers,
      titleProp = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      loading = _ref.loading;
  var title = "".concat(titleProp, " | ").concat(config/* appName */.DJ);
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();

  var _useInvoiceUploadCont = (0,useInvoiceUploadContext/* default */.Z)(),
      isFileDialogOpen = _useInvoiceUploadCont.isFileDialogOpen,
      setFileDialogOpen = _useInvoiceUploadCont.setFileDialogOpen;

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    document.body.style.setProperty('background-color', (0,Helper/* getColorFromAppState */.QV)({
      theme: theme,
      $color: backgroundColor
    }));
  }, [backgroundColor, theme]);

  var onClickScrollTopButton = function onClickScrollTopButton(event) {
    event.preventDefault();
    setFileDialogOpen(true);
  };

  var renderLoading = function renderLoading() {
    return loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutLoadingContainer */.TN, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingSpinIcon, {
        className: "animate-spin fill-primary-300 w-24 h-24"
      })
    });
  };

  var renderContent = function renderContent() {
    if (loading) {
      return renderLoading();
    }

    return children;
  };

  var renderScrollTopButton = function renderScrollTopButton() {
    var isOnInvoicesPage = router.pathname === '/dashboard/invoices';

    if (!isFileDialogOpen && !loading && isOnInvoicesPage) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Row */.X2, {
        justify: "end",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(scroll_top_button_ScrollTopButton, {
            onClick: onClickScrollTopButton
          })
        })
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      }), keywords && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: keywords.join(',')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: title
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "shortcut icon",
        type: "image/jpg",
        href: "/favicon.ico"
      }), headers]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout_styles/* LayoutMain */.Ku, {
      children: renderContent()
    }), renderScrollTopButton()]
  });
};

/* harmony default export */ var layout_Layout = (Layout);

/***/ }),

/***/ 46098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _auth_auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var useMiddleware = function useMiddleware() {
  var onlyLogged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var redirectTo = arguments.length > 1 ? arguments[1] : undefined;
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      push = _useRouter.push;

  var _useCurrentUser = (0,_auth_auth__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUser */ .xJ)(),
      isLogged = _useCurrentUser.isLogged,
      isReady = _useCurrentUser.isReady;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      allowed = _useState[0],
      setAllowed = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!enabled || !isReady) {
      return;
    }

    var disallow = !isLogged && onlyLogged || isLogged && !onlyLogged;
    setAllowed(!disallow);

    if (disallow && redirectTo) {
      push(redirectTo);
    }
  }, [isLogged, onlyLogged, redirectTo, push, isReady, enabled]);
  return {
    allowed: allowed
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useMiddleware);

/***/ }),

/***/ 98997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(41696);
// EXTERNAL MODULE: ./components/layout/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(18557);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/base/index.ts + 46 modules
var base = __webpack_require__(99535);
// EXTERNAL MODULE: ./utils/Helper.ts + 6 modules
var Helper = __webpack_require__(6435);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./auth/auth.ts + 2 modules
var auth = __webpack_require__(98541);
// EXTERNAL MODULE: ./services/user/UserService.ts
var UserService = __webpack_require__(76078);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./hooks/useAxios.ts
var useAxios = __webpack_require__(75611);
;// CONCATENATED MODULE: ./hooks/api/auth/useSignIn.ts







var useSignIn = function useSignIn() {
  var axiosInstance = (0,useAxios/* default */.Z)();

  var _useCurrentUser = (0,auth/* useCurrentUser */.xJ)(),
      setUser = _useCurrentUser.setUser,
      setAccessToken = _useCurrentUser.setAccessToken;

  return (0,useMutation/* useMutation */.D)(['userProfilePicture'], /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var data, signal;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _ref.data, signal = _ref.signal;
              _context.next = 3;
              return (0,UserService/* loginUser */.pH)(axiosInstance, data, {
                signal: signal
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    onSuccess: function onSuccess(response) {
      if (typeof response !== 'string') {
        setAccessToken(response.token);
        setUser(response);
      }
    }
  });
};

/* harmony default export */ var auth_useSignIn = (useSignIn);
// EXTERNAL MODULE: ./node_modules/validator/index.js
var validator = __webpack_require__(48966);
var validator_default = /*#__PURE__*/__webpack_require__.n(validator);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/app/login/LoginCard.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var LoginCard = function LoginCard() {
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,esm/* useTranslation */.$G)('login'),
      t = _useTranslation.t;

  var _useSignIn = auth_useSignIn(),
      signIn = _useSignIn.mutate,
      isLoading = _useSignIn.isLoading;

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(es/* object */.Ry({
      email: es/* string */.Z_().test('is-email', t('loginPage.form.email.validation.notValid'), function (value) {
        return validator_default().isEmail(value || '');
      }).required(t('loginPage.form.email.validation.required')),
      password: es/* string */.Z_().required(t('loginPage.form.password.validation.required'))
    })),
    reValidateMode: 'onChange'
  }),
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register,
      errors = _useForm.formState.errors,
      setError = _useForm.setError,
      getValues = _useForm.getValues;

  var submit = function submit(data) {
    return signIn({
      data: data
    }, {
      onSuccess: function onSuccess(response) {
        if (typeof response === 'string') {
          var email = getValues('email');

          if (email) {
            router.replace("login/verification?email=".concat(email));
            return;
          }
        }

        router.push('dashboard/invoices');
      },
      onError: function onError(error) {
        return (0,Helper/* handleFormErrorsFromAxios */.LR)(error, setError);
      }
    });
  };

  var getFieldError = function getFieldError(path) {
    var _errors$path;

    return (_errors$path = errors[path]) === null || _errors$path === void 0 ? void 0 : _errors$path.message;
  };

  var renderTitle = function renderTitle() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledH, {
      children: t('loginPage.title')
    });
  };

  var renderHeader = function renderHeader() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: "/logo.svg",
      alt: "Logo"
    });
  };

  var renderDescription = function renderDescription() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(_StyledP, {
      children: [t('loginPage.registration.description'), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/registration",
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledLink, {
          children: t('loginPage.registration.link')
        })
      })]
    });
  };

  var renderFooter = function renderFooter() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/forgotten-password",
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(_StyledLink2, {
        children: t('loginPage.forgottenPasswordLink')
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(base/* CenteredFormCard */.TY, {
    onSubmit: handleSubmit(submit),
    submitLabel: t('loginPage.form.submit'),
    loading: isLoading,
    title: renderTitle(),
    header: renderHeader(),
    footer: renderFooter(),
    description: renderDescription(),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Grid */.rj, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(base/* Row */.X2, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('loginPage.form.email.label'),
            type: "email",
            invalidMessage: getFieldError('email')
          }, register('email')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* TextField */.nv, _objectSpread({
            label: t('loginPage.form.password.label'),
            type: "password",
            invalidMessage: getFieldError('password')
          }, register('password')))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Column */.sg, {
          cols: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(base/* Checkbox */.XZ, {
            label: t('loginPage.form.rememberMe')
          })
        })]
      })
    })
  });
};

/* harmony default export */ var login_LoginCard = (LoginCard);

var _StyledH = (0,styled_components_browser_esm/* default */.ZP)("h1").withConfig({
  displayName: "LoginCard___StyledH",
  componentId: "sc-x2e5lf-0"
})({
  "fontSize": "3.75rem",
  "lineHeight": "4.538rem",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});

var _StyledP = (0,styled_components_browser_esm/* default */.ZP)("p").withConfig({
  displayName: "LoginCard___StyledP",
  componentId: "sc-x2e5lf-1"
})({
  "fontSize": "1.125rem",
  "lineHeight": "1.361rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgba(8, 15, 61, var(--tw-text-opacity))"
});

var _StyledLink = (0,styled_components_browser_esm/* default */.ZP)(base/* Link */.rU).withConfig({
  displayName: "LoginCard___StyledLink",
  componentId: "sc-x2e5lf-2"
})({
  "fontSize": "1.125rem",
  "lineHeight": "1.361rem"
});

var _StyledLink2 = (0,styled_components_browser_esm/* default */.ZP)(base/* Link */.rU).withConfig({
  displayName: "LoginCard___StyledLink2",
  componentId: "sc-x2e5lf-3"
})({
  "fontSize": "1.125rem",
  "lineHeight": "1.361rem"
});
;// CONCATENATED MODULE: ./pages/index.tsx





var LoginPage = function LoginPage() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('login'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
    title: t('loginPage.title'),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(login_LoginCard, {})
  });
};

var __N_SSP = true;
/* harmony default export */ var pages = (LoginPage);

/***/ }),

/***/ 76078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h8": function() { return /* binding */ deleteUser; },
/* harmony export */   "mg": function() { return /* binding */ getUserProfilePicture; },
/* harmony export */   "ow": function() { return /* binding */ uploadProfilePicture; },
/* harmony export */   "pH": function() { return /* binding */ loginUser; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var loginUser = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(axiosInstance, requestData) {
    var config,
        _yield$axiosInstance$,
        data,
        _args = arguments;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            _context.next = 3;
            return axiosInstance.post('auth/login', requestData, config);

          case 3:
            _yield$axiosInstance$ = _context.sent;
            data = _yield$axiosInstance$.data;

            if (!(data !== null && data !== void 0 && data.message)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", data.message);

          case 7:
            return _context.abrupt("return", data.data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loginUser(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var deleteUser = /*#__PURE__*/function () {
  var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(axiosInstance, id) {
    var config,
        _args2 = arguments;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            config = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            _context2.next = 3;
            return axiosInstance.delete("users/".concat(id), config);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function deleteUser(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var uploadProfilePicture = /*#__PURE__*/function () {
  var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(axiosInstance, photo) {
    var config,
        formData,
        _args3 = arguments;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            config = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            formData = new FormData();
            formData.set('photo', photo);
            _context3.next = 5;
            return axiosInstance.post('users/profile-picture', formData, _objectSpread(_objectSpread({}, config), {}, {
              headers: _objectSpread(_objectSpread({}, config.headers), {}, {
                'Content-Type': 'multipart/form-data'
              })
            }));

          case 5:
            return _context3.abrupt("return", _context3.sent);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function uploadProfilePicture(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
var getUserProfilePicture = /*#__PURE__*/function () {
  var _ref4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4(axiosInstance, fileUrl) {
    var config,
        _yield$axiosInstance$2,
        data,
        _args4 = arguments;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            config = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            config = _objectSpread(_objectSpread({}, config), {}, {
              responseType: config.responseType || 'blob'
            });
            _context4.next = 4;
            return axiosInstance.get(fileUrl, config);

          case 4:
            _yield$axiosInstance$2 = _context4.sent;
            data = _yield$axiosInstance$2.data;
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getUserProfilePicture(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(98997);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [535,491,966,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);